import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, NgModel } from '@angular/forms';
import { from } from 'rxjs';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-confirm-otp',
  templateUrl: './confirm-otp.component.html',
  styleUrls: ['./confirm-otp.component.scss']
})

export class ConfirmOtpComponent implements OnInit {

  confirmotpForm = new UntypedFormGroup({
    please_enter_otp: new UntypedFormControl('', Validators.required)
  })
  formFields;

  constructor(public modalRef: NgbActiveModal, private modalService: NgModel) {
  }

  ngOnInit() {
  }

  submitOTP() {
      this.modalRef.dismiss();
      //this['self'].summaryService.deleteActivitiesSeminarsSummary(this['self'].selectedRow.id).subscribe(result => {
     // this.modalService.show(MessageBoxComponent, { data: { heading: 'Confirm', content: { heading: '', description: 'Success / Failure Message' } } });
      
    //})
  }

}
